import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://media.eknepal.com" target="_blank" rel="noopener noreferrer">
          Media Alliance Nepal
        </a>
        <span className="ms-1">&copy; 2021 </span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://soanitech.com" target="_blank" rel="noopener noreferrer">
          SoAni Tech
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
